import type {
  ElementState,
  singleElementState,
  PaginationState,
} from "@/types";

import { mutations } from "./mutations";
import { actions } from "./actions";
import { getters } from "./getters";
import type { ParameterState } from "@/types/store";

const elementSate: ElementState<any> = {
  data: [],
  error: null,
  loading: false,
};
const paginationState: PaginationState = {
  data: [],
  count: 0,
  error: null,
  loading: false,
};

const ProjectVariableState: PaginationState[] = [];

const singleElementSate: singleElementState<any> = {
  data: [],
  error: null,
  loading: false,
};

export const parameterState: ParameterState = {
  clients: elementSate,
  client: singleElementSate,
  places: elementSate,
  place: singleElementSate,
  projects: elementSate,
  allProjects: elementSate,
  project: singleElementSate,
  projectEnergy: elementSate,
  variables: paginationState,
  variable: singleElementSate,
  manualVariable: singleElementSate,
  variableDatas: elementSate,
  variableRelation: elementSate,
  projectsVariables: ProjectVariableState,
  variablesByProject: paginationState,
  users: elementSate,
  user: singleElementSate,
  permissions: paginationState,
  roles: paginationState,
  aapes: singleElementSate,
  bilans: singleElementSate,
  bexSupport: singleElementSate,
  perimetres: singleElementSate,
  choices: singleElementSate,
  bexChoices: singleElementSate,
  bexSupportFiles: singleElementSate,
};

export const ParameterModule = {
  namespaced: true,
  state: parameterState,
  getters,
  actions,
  mutations,
};
